<template>
    <div class="news_banner_09m">
        <div class="swiper-news-box">
            <div class="left_btn" @click="cut()">
                <img src="../../public/img/09m/home/left.png" alt="" srcset="">
            </div>
            <div class="right_btn" @click="add()">
                <img src="../../public/img/09m/home/right.png" alt="" srcset="">
            </div>
            <div class="swiper-news">
                <div class="swiper-wrapper" >
                    <div class="swiper-slide"  v-for="(item, index) in bannerList" :key="index">
                         <!-- <div class="itemImg" :style="`background-image:url('${baseUrl+'img/news/'+item.img}')`"> -->
                         <div class="itemImg" :style="`background-image:url('${item.img_url}')`">
                            <div class="itemText">{{$i18n.locale=='zh'?  item.title_zh: item.title_en}}</div>
                        </div>
                    </div>                
                </div>
            </div>
            <div class="more" @click="gotoNews()">
                <div>{{$t('更多')}}</div>
                <img src="../../public/img/09m/home/more.png" alt="" srcset="">
            </div>
        </div>
    </div>
</template>
<script>
import Swiper from 'swiper';
import {getNewsData} from "../datas/newsData.js"
import {getAllNews} from '../datas/ajax'
export default {
    data() {
        return {
            baseUrl:process.env.BASE_URL, 
            bannerList:[],
            indexs:0
        }
    },
    created(){
        this.render()
    },
    mounted(){
        let _this = this
        this.mySwiper = new Swiper('.swiper-news',{
            loop:false,
            grabCursor: true,
            slidesPerView: 'auto',   //设置slider容器能够同时显示的slides数量
            paginationClickable: true,
            autoplay: true,
            observer:true,
            on:{
                transitionEnd: function(swiper){
                    _this.indexs = swiper.realIndex
                },
                click:function(swiper){
                    // _this.$router.push( _this.productList[swiper.clickedIndex%7].url)
                    _this.$router.push('/newsDetails/'+swiper.clickedIndex%(_this.bannerList.length))
                }                
            },
        });
        this.timer = setInterval(()=>{
           this.mySwiper.slideNext();
        },5000)
    },
    methods:{
        render(){
            getAllNews((data)=>{
                // this.bannerList = getNewsData()
                this.bannerList = data
            })
        },
        add(){
            this.mySwiper.slideNext();  
        },
        cut(){
            this.mySwiper.slidePrev();
        },
        gotoNews(){
            this.$router.push('/news')
        },
    }
}
</script>
<style lang="less" scoped>
.news_banner_09m{
    @height:100vw/2.28;
    @width:100vw;
    @swiperWidth:100vw*0.7;
    @swiperHeight:100vw*0.12;    
    width: @width;
    height: @height;
    background-image: url('../../public/img/09m/home/新闻背景.jpg');
    background-size: 100% auto;
    background-position-y: 30%;
    .more{
        position: absolute;
        left: 50%;
        cursor: pointer;
        bottom: 0%;
        transform: translate(-50%,130%);
        width: 5rem;
        height: 1.8rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.8rem;
        font-weight: 400;
        background-image: linear-gradient(90deg,#009D40,#007CA9);
        color: #ffffff;
        img{
            height: 40%;
            margin-left: 9px;
        }
    }
    .left_btn{
        position: absolute;
        left: 0;
        top: 50%;
        transform: translate(-8vw,-50%);
        width: 3.5vw;
        height: 3.5vw;
        border-radius: 50%;
        background-color: #ffffff;
        box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        img{
            height: 60%;
            transform: translateX(-10%);
        }
    }
    .right_btn{
        position: absolute;
        right: 0;
        top: 50%;
        transform: translate(8vw,-50%);
        width: 3.5vw;
        height: 3.5vw;
        border-radius: 50%;
        cursor: pointer;
        background-color: #ffffff;
        box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
        display: flex;
        align-items: center;
        justify-content: center;
        img{
            height: 60%;
            transform: translateX(10%);
        }
    }
    .swiper-news-box{
        width: @swiperWidth;
        height: @swiperHeight;  
        margin: 0 auto;
        position: relative;
        .swiper-news{
            width: 100%;
            height: 100%;
            overflow: hidden;
            .swiper-wrapper{
                width: 100%;
                height: 100%;
            }
            .swiper-slide{
                width: 33.33%;
                display: flex;
                align-items: center;
                justify-content: center;
                .itemImg{
                    width: 90%;
                    height: 90%;
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: center;
                    box-shadow: 0 0 5px rgba(0, 0, 0, 0.6);
                    position: relative;
                    .itemText{
                        color: #fff;
                        position: absolute;
                        bottom: 10px;
                        font-size: 0.7rem;
                        text-align: center;
                        width: 80%;
                        margin-left: 10%;
                        text-overflow:ellipsis;
                        overflow:hidden;
                        white-space:nowrap; 
                        z-index: 1000;
                    }
                }
                .itemImg::before{
                    content: '';
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    z-index: 100;
                    opacity: 0.8;
                    background-image: linear-gradient(rgba(1, 124, 164,0.2) 40%, #017CA4 90%);
                }
            }
        }
    }
}
</style>
<i18n>
{
    "en":{
        "更多":"More"
    },
    "zh":{
        "更多":"更多"
    }    
}
</i18n>
